<template>
  <div class="app-container member-list">
    <div class="member-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input
              class="member-list-filter-value"
              clearable
              size="small"
              placeholder="Birth Name"
              suffix-icon="el-icon-search"
              v-model.trim="search.realname"
              @keyup.enter.native="searchChange"
            />
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input
              class="member-list-filter-value"
              clearable
              size="small"
              placeholder="员工号"
              suffix-icon="el-icon-search"
              v-model.trim="search.unionId"
              @keyup.enter.native="searchChange"
            />
          </div>
        </el-col>
        <el-col :span="6"></el-col>
        <el-col :span="6">
          <div>
            <el-button class="member-list-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="member-list-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <basic-container class="member-list-container">
      <avue-crud
        ref="crud"
        :option="memberOrganizationTagTableOption"
        :data="list"
        :page="page"
        :table-loading="listLoading"
        @current-change="handleCurrentChange"
        @refresh-change="handleRefreshChange"
        @size-change="handleSizeChange"
        @sort-change="handleSortChange">
        <template slot="menuLeft">
          <el-button
            v-if="permissions.organization_tag_member_add"
            lass="filter-item"
            size="small"
            type="primary"
            @click="handleAdd"
            icon="el-icon-plus">
            新增
          </el-button>
        </template>
        <template slot="menu" slot-scope="scope">
          <el-button
            v-if="permissions.organization_tag_member_delete"
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)">
            删除
          </el-button>
        </template>
      </avue-crud>
    </basic-container>

    <el-dialog
      title="新增用户"
      :visible.sync="addDialogVisible"
      width="30%">
      <template>
        <div>
          <el-label class="edit-dialog-item-label">标签ID</el-label>
          <el-input v-model="tagId" disabled />
        </div>
        <div>
          <el-label class="edit-dialog-item-label">请输入员工号</el-label>
          <el-input
            clearable
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请输入员工号，多个员工号请用英文逗号’,‘分隔"
            v-model="unionIds">
          </el-input>
          <div class="tip">多个员工号请用英文逗号’,‘分隔</div>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAddSubmit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    fetchMemberTagList,
    deleteMemberTag,
    addMemberTag,
  } from '@/api/admin/member';
  import { memberOrganizationTagTableOption } from '@/const/crud/admin/member';
  import { mapGetters } from 'vuex';

  export default {
    name: 'organization-tag-member',
    data() {
      const { tagId } = this.$route.params;
      return {
        search: {
          current: 1,
          size: 10,
          realname: '',
          unionId: '',
          sortField: 'id',
          sortPolicy: 'desc',
        },
        page: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
        },
        list: [],
        listLoading: false,
        memberOrganizationTagTableOption,
        addDialogVisible: false,
        tagId,
        unionIds: '',
      };
    },
    created() {
      this.initPage();
      this.getList();
    },
    computed: {
      ...mapGetters(['permissions']),
    },
    methods: {
      initPage() {
        this.page.currentPage = 1
        this.page.pageSize = this.search.size
        this.search.current = 1
      },
      getList() {
        const { tagId } = this.$route.params;
        const { current, size, realname, unionId, sortField, sortPolicy } = this.search;
        const params = { current, size, sortField, sortPolicy };
        if (realname.trim()) params.realname = realname;
        if (unionId.trim()) params.unionId = unionId;

        this.listLoading = true;
        fetchMemberTagList(tagId, params)
          .then((response) => {
            const { records, total } = response.data.data
            this.list = records;
            this.page.total = total;
          })
          .catch((err) => {
            this.$message.error(err);
          })
          .finally(() => {
            this.listLoading = false;
          });
      },
      searchChange() {
        this.initPage();
        this.getList();
      },
      searchReset() {
        this.search.realname = '';
        this.search.unionId = '';
        this.searchChange();
      },
      handleCurrentChange(val) {
        this.page.currentPage = val;
        this.search.current = val;
        this.getList();
      },
      handleRefreshChange() {
        this.getList();
      },
      handleSizeChange(val) {
        this.page.pageSize = val;
        this.page.currentPage = 1;
        this.search.size = val;
        this.search.current = 1;
        this.getList();
      },
      handleSortChange(val) {
        if (val.prop == "insertedTime") {
          this.search.sortField = "id"
        } else {
          this.search.sortField = ""
        }
        if (val.order == 'ascending') {
          this.search.sortPolicy = "asc"
        } else if (val.order == 'descending') {
          this.search.sortPolicy = "desc"
        } else {
          this.search.sortField = "id"
          this.search.sortPolicy = "desc"
        }
        this.getList()
      },
      handleDelete(row) {
        const { realname, tagName, id } = row;
        this.$confirm(`是否确认删除用户【${realname}】的标签【${tagName}】?`, '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          return deleteMemberTag(id);
        }).then(() => {
          this.getList();
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          });
        }).catch(() => {});
      },
      handleAdd() {
        this.unionIds = '';
        this.addDialogVisible = true;
      },
      handleAddSubmit() {
        if(!this.unionIds) {
          this.$message.error('请输入员工号');
          return false;
        }

        addMemberTag(this.tagId, this.unionIds)
          .then(() => {
            this.getList();
            this.$message({
              showClose: true,
              message: '新增用户成功',
              type: 'success',
            });
            this.addDialogVisible = false;
          })
          .catch(() => {});
      },
    }
  };
</script>

<style lang="scss" scoped>
.member-list {
  &-filter {
    margin: 0 10px;

    /deep/ .el-input__inner {
      font-size: 14px;
      border: unset;
    }

    .el-row {
      width: 95%;
    }

    &-empty {
      display: block;
    }

    &-label {
      margin-right: 10px;
      color: #606266;
      font-size: 14px;
    }

    &-value {
      width: calc(100% - 12px) !important;
    }

    &-location-value {
      width: calc(100% - 12px) !important;

      input {
        border: unset !important;
      }
    }

    &-date {
      width: calc(100% - 180px) !important;
    }

    &-search {
      float: right;
      margin-right: 10px;
    }

    &-reset {
      float: right;
      margin-right: 10px;
      color: #5383f3;
      border-color: #5383f3;
    }
  }

  &-container {
    padding-top: 0;

    &-button {
      color: #409eff;
      font-weight: 500;
      font-size: 14px;
      text-align: center;
    }
  }

  .tip {
    margin-top: 4px;
    color: #ccc;
    font-size: 12px;
  }
}

.upload-dialog {
  .upload-dialog-input {
    margin: 5px 0;
  }
}

/deep/ .el-upload-list {
  height: 50px;
}

.edit-dialog-item-label {
  display: inline-block;
  margin: 10px 0;
}

</style>
